interface CaptionElementProps {
    caption?: string
}

export default function CaptionElement({ caption }: CaptionElementProps) {
    return (
        <figcaption className="Trade_Gothic_Text_Bold_14_150_0_700 lg:Trade_Gothic_Text_Bold_16_150_0_700">
            {caption}
        </figcaption>
    )
}
